/**
 * Created by dillon on 2/5/16.
 */

jQuery( document ).ready(function($) {
    "use strict";

    if(window.location.href.indexOf("#myModal-finale") != -1) {
        $("#myModal-finale").modal("show");
    }


    // ADD SLIDEDOWN ANIMATION TO DROPDOWN //
    $(".dropdown").on("show.bs.dropdown", function(e){
        $(this).find(".dropdown-menu").first().stop(true, true).slideDown();
    });

    // ADD SLIDEUP ANIMATION TO DROPDOWN //
    $(".dropdown").on("hide.bs.dropdown", function(e){
        $(this).find(".dropdown-menu").first().stop(true, true).slideUp();
    });

    // Sticky Header
    var header = $(".header");
    $(window).scroll(function() {
        var scroll = $(window).scrollTop();

        if (scroll >= 820) {
            header.removeClass("not-sticky").addClass("sticky");
        } else {
            header.removeClass("sticky").addClass("not-sticky");
        }
    });


    // Amenities Slider
    $(".slick-slider").slick({
        //setting-name: setting-value
        slidesToShow: 1,
        slidesToScroll: 1,
        prevArrow: ".left-arrow-amen",
        nextArrow: ".right-arrow-amen",
        asNavFor: '.bg-slider',
        // autoplaySpeed: 2000
    });

    $(".bg-slider").slick({
        //setting-name: setting-value
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        // autoplaySpeed: 2000
    });


    $(".single-amenity").on("click", function(e) {
        var slide_id = $(e.currentTarget).attr("data-id");

        $(".slick-slider").slick("slickGoTo", slide_id);

        if (slide_id == 1){
            $(this).addClass("fullopacity");
        }

    });

    // Hero Slider 1
    $(".hero-slider-1").slick({
        //setting-name: setting-value
        slidesToShow: 1,
        slidesToScroll: 1,
        fade:true,
        cssEase: "linear",
        useCSS: true,
        arrows:false,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false,
    });

    // Hero Slider 2
    $(".hero-slider-2").slick({
        //setting-name: setting-value
        slidesToShow: 1,
        slidesToScroll: 1,
        fade:true,
        cssEase: "linear",
        useCSS: true,
        arrows:false,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false,
    });

    // Hero Slider 3
    $(".hero-slider-3").slick({
        //setting-name: setting-value
        slidesToShow: 1,
        slidesToScroll: 1,
        fade:true,
        cssEase: "linear",
        useCSS: true,
        arrows:false,
        autoplay: true,
        autoplaySpeed: 3500,
        pauseOnHover: false,
    });

    // Availabiliies Slider
    $(".availabilities-slider").slick({
        //setting-name: setting-value
        infinite: false,
        slidesToShow: 6,
        slidesToScroll: 3,
        prevArrow: ".left-arrow-avail",
        nextArrow: ".right-arrow-avail",
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 3,
                    infinite: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            }
        ]
    });


    // Greensock Animation on Page Load
    TweenMax.set(".hero-slider-1", {top:900, opacity: 0});
    TweenMax.to(".hero-slider-1",1, {ease: Back.easeOut, top:0, opacity: 1,});

    TweenMax.set(".hero-slider-2", {top:900, opacity: 0});
    TweenMax.to(".hero-slider-2",1, {ease: Back.easeOut, top:0, opacity: 1, delay:0.2});

    TweenMax.set(".hero-slider-3", {top:900, opacity: 0});
    TweenMax.to(".hero-slider-3",1, {ease: Back.easeOut, top:0, opacity: 1, delay:0.4});

    TweenMax.set(".logo-img", {top:100, opacity: 0});
    TweenMax.to(".logo-img",1, {ease: Power1.easeIn, top:0, opacity: 1});

    TweenMax.set(".weather-contact", {top:-50, opacity: 0});
    TweenMax.to(".weather-contact",1, {ease: Power1.easeIn, top:0, opacity: 1, delay:1});

    TweenMax.staggerFromTo(".menu-item a", 1, {top: 100, opacity:0}, {top: 0, opacity:1, ease: Back.easeOut}, 0.15);


    $(".menu-item a").hover(menu_over, menu_out);

    function menu_over(){
        TweenMax.to(this, 0.5, {color:"#77bd43"});
    }

    function menu_out(){
        TweenMax.to(this, 0.5, {color:"#ffffff"});
    }


    // Scroll Magic
    var controller = new ScrollMagic.Controller();

    var scene = new ScrollMagic.Scene({
        triggerElement: "#trigger-intro-title", triggerHook: "onEnter", offset:300
    })
        .setTween("#animate-intro-title", 0.5, {top: 0, opacity:1}) // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);

    var scene = new ScrollMagic.Scene({
        triggerElement: "#trigger-intro-title", triggerHook: "onEnter", offset:300
    })
        .setTween("#animate-intro-title", 0.5, {top: 0, opacity:1}) // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);

    var scene1 = new ScrollMagic.Scene({
        triggerElement: "#trigger-intro-paragraph", triggerHook: "onEnter", offset:300
    })
        .setTween("#animate-intro-paragraph", 0.5, {top: 0, opacity:1}) // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);

    var scene2 = new ScrollMagic.Scene({
        triggerElement: "#trigger-intro-paragraph", triggerHook: "onEnter", offset:300
    })
        .setTween(".vid-links", 2, {opacity:1}) // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);

    var scene3 = new ScrollMagic.Scene({
        triggerElement: "#trigger-intro-vid", triggerHook: "onEnter", offset:300
    })
        .setTween("#animate1", 0.5, {top: 0, ease: Back.easeOut}) // trigger a TweenMax.to tween
        //.addIndicators({name: "1 (duration: 0)"}) // add indicators (requires plugin)
        .addTo(controller);


    // build tween
    var tweenIcons = TweenMax.staggerFromTo(".single-amenity", 2, {left: -400, opacity:0}, {left: 0, opacity:0.4, ease: Back.easeOut}, 0.15);

    // build scene
    var scene4 = new ScrollMagic.Scene({triggerElement: "#trigger-amenities-icons"})
        .setTween(tweenIcons)
        //.addIndicators({name: "staggering"}) // add indicators (requires plugin)
        .addTo(controller);



    $(".single-amenity").hover(amenity_over, amenity_out);

    function amenity_over(){
        TweenMax.to(this, 0.5, {opacity:1});
    }

    function amenity_out(){
        TweenMax.to(this, 0.5, {opacity:0.4});
    }

    $(".video-hover-1").hover(video_over_1, video_out_1);

    function video_over_1(){
        TweenMax.to(".video-title-1", 0.5, {top:90});
        TweenMax.to(".play-button-1", 0.5, {top:120, opacity:1});
    }

    function video_out_1(){
        TweenMax.to(".video-title-1", 0.5, {top:110});
        TweenMax.to(".play-button-1", 0.5, {top:180, opacity:0});
    }

    $(".video-hover-2").hover(video_over_2, video_out_2);

    function video_over_2(){
        TweenMax.to(".video-title-2", 0.5, {top:170});
        TweenMax.to(".play-button-2", 0.5, {top:200, opacity:1});
    }

    function video_out_2(){
        TweenMax.to(".video-title-2", 0.5, {top:190});
        TweenMax.to(".play-button-2", 0.5, {top:260, opacity:0});
    }

    $(".video-hover-3").hover(video_over_3, video_out_3);

    function video_over_3(){
        TweenMax.to(".video-title-3", 0.5, {top:170});
        TweenMax.to(".play-button-3", 0.5, {top:200, opacity:1});
    }

    function video_out_3(){
        TweenMax.to(".video-title-3", 0.5, {top:190});
        TweenMax.to(".play-button-3", 0.5, {top:260, opacity:0});
    }

    $(".video-hover-4").hover(video_over_4, video_out_4);

    function video_over_4(){
        TweenMax.to(".video-title-4", 0.5, {top:90});
        TweenMax.to(".play-button-4", 0.5, {top:120, opacity:1});
    }

    function video_out_4(){
        TweenMax.to(".video-title-4", 0.5, {top:110});
        TweenMax.to(".play-button-4", 0.5, {top:180, opacity:0});
    }

    $(".video-hover-finale").hover(video_over_finale, video_out_finale);
    
    function video_over_finale(){
        TweenMax.to(".video-title-finale", 0.5, {top:90});
        TweenMax.to(".play-button-finale", 0.5, {top:120, opacity:1});
    }

    function video_out_finale(){
        TweenMax.to(".video-title-finale", 0.5, {top:110});
        TweenMax.to(".play-button-finale", 0.5, {top:180, opacity:0}); 
    }


    // build tween
    var tween2 = TweenMax.staggerTo(["#animate-vid-finale", "#animate-vid-why","#animate-vid-1","#animate-vid-2","#animate-vid-3","#animate-vid-4"], 1,
        {marginTop: 0, opacity:1}, 0.25
    );

		// build scene
    var scene5 = new ScrollMagic.Scene({triggerElement: "#trigger-vid-animation",triggerHook: "onEnter", duration: 500, offset: 300})
        .setTween(tween2)
        // .addIndicators({name: "loop"}) // add indicators (requires plugin)
        .addTo(controller);

    // Smooth Scroll
    $('a[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//,'') == this.pathname.replace(/^\//,'') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) +']');
            if (target.length) {
                $("html, body").animate({
                    scrollTop: target.offset().top
                }, 1000);
                return false;
            }
        }
    });

    // Full Screen Slideshow
    $(".image-gallery-main, .image-gallery-1, .image-gallery-2, .image-gallery-3,.image-gallery-4, .image-gallery-5, .image-gallery-6, .image-gallery-7").fullscreenslides();

    // All events are bound to this container element
    var $container = $("#fullscreenSlideshowContainer");

    $container
    //This is triggered once:
        .bind("init", function() {

            // The slideshow does not provide its own UI, so add your own
            // check the fullscreenstyle.css for corresponding styles
            $container
                .append('<div class="ui" id="fs-close"></div>')
                .append('<div class="ui" id="fs-loader">Loading...</div>')
                .append('<div class="ui" id="fs-prev"><i class="fa fa-angle-left"></i></div>')
                .append('<div class="ui" id="fs-next"><i class="fa fa-angle-right"></i></div>')
                .append('<div class="ui" id="fs-caption"><span></span></div>');

            // Bind to the ui elements and trigger slideshow events
            $("#fs-prev").click(function(){
                // You can trigger the transition to the previous slide
                $container.trigger("prevSlide");
            });
            $("#fs-next").click(function(){
                // You can trigger the transition to the next slide
                $container.trigger("nextSlide");
            });
            $("#fs-close").click(function(){
                // You can close the slide show like this:
                $container.trigger("close");
            });

        })
        // When a slide starts to load this is called
        .bind("startLoading", function() {
            // show spinner
            $("#fs-loader").show();
        })
        // When a slide stops to load this is called:
        .bind("stopLoading", function() {
            // hide spinner
            $("#fs-loader").hide();
        })
        // When a slide is shown this is called.
        // The "loading" events are triggered only once per slide.
        // The "start" and "end" events are called every time.
        // Notice the "slide" argument:
        .bind("startOfSlide", function(event, slide) {
            // set and show caption
            $("#fs-caption span").text(slide.title);
            $("#fs-caption").show();
        })
        // before a slide is hidden this is called:
        .bind("endOfSlide", function(event, slide) {
            $("#fs-caption").hide();
        });



});


//Input Field Animation
(function () {
    // trim polyfill : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/Trim
    if (!String.prototype.trim) {
        (function () {
            // Make sure we trim BOM and NBSP
            var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
            String.prototype.trim = function () {
                return this.replace(rtrim, "");
            };
        })();
    }

    [].slice.call(document.querySelectorAll("input.input__field")).forEach(function (inputEl) {
        // in case the input is already filled..
        if (inputEl.value.trim() !== "") {
            classie.add(inputEl.parentNode, "input--filled");
        }

        // events:
        inputEl.addEventListener("focus", onInputFocus);
        inputEl.addEventListener("blur", onInputBlur);
    });

    function onInputFocus(ev) {
        classie.add(ev.target.parentNode, "input--filled");
    }

    function onInputBlur(ev) {
        if (ev.target.value.trim() === "") {
            classie.remove(ev.target.parentNode, "input--filled");
        }
    }
})();


// v3.1.0
//Docs at http://simpleweatherjs.com
$(document).ready(function() {
    $.simpleWeather({
        location: "Oakbrook, IL",
        woeid: "",
        unit: "f",
        success: function(weather) {
            html = '<h2><i class="icon-'+weather.code+'"></i> '+weather.temp+'&deg;'+weather.units.temp+'</h2>';

            $("#weathertop").html(html);
        },
        error: function(error) {
            $("#weathertop").html('<p>'+error+'</p>');
        }
    });
});

$(document).ready(function() {
    $.simpleWeather({
        location: 'Oakbrook, IL',
        woeid: '',
        unit: 'f',
        success: function(weather) {
            html = '<h2><i class="icon-'+weather.code+'"></i> '+weather.temp+'&deg;'+weather.units.temp+'</h2>';
            html += '<li class="currently">'+weather.currently+'</li>';
            html += '<a href="https://www.yahoo.com/news/weather/united-states/illinois/oak-brook-2462685" target="_blank" class="link btn-weather btn-resources">VIEW FORECAST</a>';

            $("#weather").html(html);
        },
        error: function(error) {
            $("#weather").html('<p>'+error+'</p>');
        }
    });
});